export const OPT_OUT_GROUPS_MAP = {
  necessary: 1,
  marketing: 2,
  personalisation: 3,
  analytics: 4,
  other: 5,
  socialMedia: 6,
};
